import client from '../utillities/Client'
const useClient = () => {
  return client
}
export default useClient
